import React from 'react';
import RadialOrbitalTimeline from '../ui/radial-orbital-timeline';
import { FiMapPin, FiScissors, FiSettings, FiCheckCircle, FiPackage, FiGlobe } from 'react-icons/fi';

const timelineData = [
  { id: 1, title: "Plantation", date: "Phase 1", content: "Cultivated in fertile Ceylon soils under optimal climate conditions.", category: "Sourcing", icon: FiMapPin, relatedIds: [2], status: "completed", energy: 15 },
  { id: 2, title: "Harvesting", date: "Phase 2", content: "Hand-picked at peak maturity by experienced local farmers.", category: "Harvesting", icon: FiScissors, relatedIds: [1, 3], status: "completed", energy: 30 },
  { id: 3, title: "Processing", date: "Phase 3", content: "Traditional and modern techniques combined to preserve quality.", category: "Processing", icon: FiSettings, relatedIds: [2, 4], status: "in-progress", energy: 50 },
  { id: 4, title: "Quality Testing", date: "Phase 4", content: "Rigorous testing to meet international export standards.", category: "Testing", icon: FiCheckCircle, relatedIds: [3, 5], status: "pending", energy: 70 },
  { id: 5, title: "Packaging", date: "Phase 5", content: "Carefully sealed to preserve maximum freshness and aroma.", category: "Packaging", icon: FiPackage, relatedIds: [4, 6], status: "pending", energy: 85 },
  { id: 6, title: "Delivery", date: "Phase 6", content: "Shipped worldwide from our home in Ceylon to yours.", category: "Delivery", icon: FiGlobe, relatedIds: [5], status: "pending", energy: 100 }
];

const Process = () => {
  return (
    <section className="py-24 px-6 bg-[#e8e4d9] relative overflow-hidden">
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-darkSage">
            FROM CEYLON TO YOU
          </h2>
        </div>
        
        {/* Increased height to accommodate the larger timeline */}
        <div className="w-full h-[700px] md:h-[900px] -mt-10">
          <RadialOrbitalTimeline timelineData={timelineData} />
        </div>
      </div>
    </section>
  );
};

export default Process;